
import Box from "@mui/material/Box";
import MainActivity from "./page/MainActivity";
import MapWithParticles from "./page/Mapwithpracticles";

import "./App.css";
import "./css/style.css";

function App() {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minWidth: 0,
        minHeight: "100dvh",
        height: { xs: "auto", lg: "100vh" },
        overflowX: "clip",
        overflowY: { xs: "visible", lg: "hidden" },
      }}
    >
      {/* Арын дэвсгэр */}
      <Box
        aria-hidden="true"
        sx={{
          position: "fixed",
          inset: 0,
          width: "100%",
          height: "100dvh",
          zIndex: 0,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        <MapWithParticles />
      </Box>

      {/* Dashboard */}
      <Box
        component="main"
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          minWidth: 0,
          height: "auto",
          minHeight: "100dvh",
          display: "block",
          overflow: "visible",
          pt: 0,
          mt: 0,
        }}
      >
        <MainActivity />
      </Box>
    </Box>
  );
}

export default App;
